import {
  Box,
  Container,
  Grid,
  Skeleton,
  Stack,
  styled,
  SwipeableDrawer,
  TextField,
  Typography,
  IconButton,
  Button,
  CircularProgress,
  Divider,
  Card,
  CardMedia,
} from "@mui/material";
import {
  addDoc,
  collection,
  doc,
  getDoc,
  getDocs,
  limit,
  orderBy,
  query,
  serverTimestamp,
  setDoc,
  where,
} from "firebase/firestore";
import React, { useState } from "react";
import { UserAuth } from "../context/AuthContext";
import { db } from "../firebase.config";
import CustomButton from "../Components/CustomButton";
import EventCard from "../Components/EventCard";
import Iconify from "../Components/Iconify";
import { sendPasswordResetEmail } from "firebase/auth";
import { Facebook, Google } from "@mui/icons-material";
import { Variables } from "../context/VariableContext";
import CustomTextField from "../Components/CustomTextField";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { useNavigate } from "react-router-dom";

const Home = ({ open, count }) => {
  const { user } = UserAuth();
  const navigate = useNavigate()
  const { openLogin, setOpenLogin } = Variables();
  const [loading, setLoading] = React.useState(false);
  const [events, setEvents] = React.useState([]);
  
  React.useEffect(() => {
    (async () => {
      try {
        setEvents([])
        console.log(user)
        const q = query(collection(db, `partners/${user.uid}/affiliations`));
        const snapshot = await getDocs(q);
        snapshot.forEach(async (d) => {
          const docRefCampaign = doc(db, 'evenement', `${d.id.split('-')[0]}`);
          const docSnapCampaign = await getDoc(docRefCampaign);
          if (docSnapCampaign.exists()) {
            setEvents((events) => [...events, {affId: d.data().affId, id: d.id, data: docSnapCampaign.data() }]);
          }
        });
      } catch (error) {
        console.log(error);
      }
      setLoading(false);
    })();
  }, [user]);

  const goToEvent = (index) => {
    navigate(`/affiliation/${events[index].affId}&${events[index].id}`)
  };

  const [openConnexion, setOpenConnexion] = React.useState(open);
  const [connexion, setConnexion] = React.useState(0);



  return (
    <Container>
      <Stack sx={{ color: 'white' }} spacing={3}>
        <Typography variant="h4">Vos affiliations</Typography>
        
        <Stack spacing={2} justifyContent='center' paddingTop={2}>
          {
            events.length === 0 && loading && <>
            <Typography variant="body2">Vous n'êtes affilié a aucun évenement pour le moment</Typography>
            <Typography variant="body2">Veuillez contacter des organisateurs pour mettre en place des partenariat</Typography>
            </> 
          }
          
          <CustomTextField placeholder='Rechercher un evenement'/>
          {events.map((event, index) => (
            <Card sx={{bgcolor:'#292929', color:'white', cursor:'pointer', padding:1}} onClick={() => goToEvent(index)}>
              <Stack direction='row' spacing={2} display="flex" alignItems="center">

                <LazyLoadImage
                  src={`${event.data.idVisuel}`}
                  alt={`${event.data.idVisuel}`}
                  className="img-lazy"
                  width={100}
                  height={100}
                  style={{ objectFit: 'cover', borderRadius:'7px' }}
                  effect="blur" // opacity | black-and-white
                />
                <Box>
                  <Typography variant="subtitle1">{event?.data.nomEvent}</Typography>
                  <Typography variant="body2" >
                    dans 3 jours
                  </Typography>
                  <Typography variant="body2" >
                    {event?.data.participant} participants
                  </Typography>
                </Box>
              </Stack>
            </Card>))}
          <Stack>

          </Stack>
        </Stack>
      </Stack>

    </Container>
  );
};

export default Home;
